import React from "react";
import imageUrl from "utils/imageUrl";
import { Link } from "react-router-dom";

function Banner() {
  return (
    // <!-- ==== hero section start ==== -->
    <section
      className="hero pos__rel over__hi bg__img"
      //   data-background={imageUrl("02.jpg")}
      style={{ backgroundImage: `url(${imageUrl("home/02.jpg")})` }}
    >
      <div className="bg__shadow position-absolute"></div>
      <div className="container">
        <div className="hero__area">
          <div className="row">
            <div className="col-lg-6 col-xxl-5">
              <div className="hero__content pos__rel">
                {/* <h5 className="neutral-top">A smarter, better way to invest</h5> */}
                <h1 className="text-white">
                  Real Estate Investment For <span>Everyone</span>{" "}
                </h1>
                <p className="primary neutral-bottom text-white">
                  Buy shares of rental properties, earn monthly income, and
                  watch your money grow
                </p>
                <div className="hero__cta__group">
                  <Link to="/explore" className="button button--effect">
                    Start Exploring
                  </Link>
                  <Link
                    to="/buy-prop-details"
                    className="button button--secondary button--effect"
                  >
                    List Now
                  </Link>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-6 col-xxl-6 offset-xxl-1">
              <div className="hero__illustration d-none d-lg-block">
                <img
                  src={imageUrl("hero-illustration.png")}
                  alt="Hero Illustration"
                />
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
    // <!-- ==== #hero section end ==== -->
  );
}

export default Banner;
